// STATE RATE:  10% of penal amount. $100 minimum 
//              STATE RATE of 15% Capital Offense or defendant resides outside 
//              the State of Mississippi charge on additional $50 processing 
//              fee on each bond issued.                                                                                                       

// IMMIGRATION: 15% of the penal amount. $100 mimimum. The premium will be
//              charged and collected  on an annual basis untill the surety
//              is legally dischared form all liability on the bonds(s)

/* eslint-disable */
export const equation = ({ bondValue, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 100
  if (type === 'STATE') {
    value = (bondValue * .1)
    if (
      additional.crimeType === 'CAPITAL_OFFENSE' || 
      additional.defendantResidence === 'OUTSIDE'
    ) {
      value = (bondValue * .15)
    }
    if (value < 100) {
      value = 100
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation